import React from 'react';
import styled from 'styled-components';

import { Modal } from './base-modal';
import { ModalBody } from './modal-body';
import { ModalFooter } from './modal-footer';
import { ModalHeader } from './modal-header';
import { ConfirmModalProps } from './types';

const MessageText = styled.p`
  padding: 16px;
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.modal.header.subHeaderColor};
`;

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  onClose,
  destructive = false,
  loading = false,
  size = 'sm',
}) => (
  <Modal
    open={open}
    onClose={onClose}
    onCancel={onCancel}
    onConfirm={onConfirm}
    size={size}
    loading={loading}
    closeOnOverlayClick={true}
    closeOnEsc={true}
  >
    <ModalHeader title={title} />
    <ModalBody>
      {typeof message === 'string' ? <MessageText>{message}</MessageText> : message}
    </ModalBody>
    <ModalFooter
      confirmText={confirmText}
      cancelText={cancelText}
      onConfirm={onConfirm}
      destructive={destructive}
    />
  </Modal>
);
